import { render, staticRenderFns } from "./BudgetClarifyIncome.vue?vue&type=template&id=16b97932&"
import script from "./BudgetClarifyIncome.vue?vue&type=script&lang=ts&"
export * from "./BudgetClarifyIncome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports